import { useEffect, Fragment, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ImageGallery from '../../components/ImageGallery';
import Info from '../../components/Info';
import Table from '../../components/Table';
import InfoDescription from '../../components/InfoDescription';
import Price, { CURRENCY } from '../../components/Price';
import { RepositoryContext } from '../../store/RepositoryProvider';
import API from '../../server/api';
import log from '../../utils/logger';
import ReportParams from '../../models/report/ReportParams';
import Subdivision from '../../models/subdivision/Subdivision';
import Section from '../../components/Section';

const ExcursionInfo = ({ excursion, prices }) => {
  const {t} = useTranslation(['common', 'excursion']);

  const repository = useContext(RepositoryContext);

  const [accountObjects, setAccountObjects] = useState({});
  const [accountObjectServices, setAccountObjectServices] = useState({});

  const loadAccountObjects = async () => {
    let newAccountObjects = {};
    let newAccountObjectServices = {};

    for (let subdivision of excursion.subdivisions) {
      const subData = await repository.action(API.subdivision.subdivision, {id: subdivision.subdivision.id}, Subdivision);
      subdivision.title = subData.title;

      const priceMap = prices.reduce((o, p) => { o[p.id] = p; return o; }, {});
      for (let accountObject of subdivision.objects) {
        if (!newAccountObjects[accountObject.id]) {
          try {
            newAccountObjects[accountObject.id] = await repository.action(API.object.accountObjects, {id: accountObject.id});
            let params = new ReportParams();
            params.id = accountObject.id;
            let report = await repository.report(API.object.services, params);
            newAccountObjectServices[accountObject.id] = report.rows;
            newAccountObjectServices[accountObject.id].forEach((service) => {
              service.prices.forEach((price) => {
                let title = priceMap[price.objectPrice].title;
                if (price.minAge >= 0 || price.maxAge >= 0) {
                  if (price.minAge >= 0 && price.maxAge >= 0) {
                    title += ` ${t('common:age.fromto', { from: price.minAge, to: price.maxAge })}`;
                  } else if (price.minAge >= 0) {
                    title += ` ${t('common:age.from', { age: price.minAge })}`;
                  } else if (price.maxAge >= 0) {
                    title += ` ${t('common:age.to', { age: price.maxAge })}`;
                  }
                }
                price.title = title;
              })
            });
          } catch (e) {
            log.error(e);
            newAccountObjects[accountObject.id] = null;
          }
        }
      }
    }
    setAccountObjects(newAccountObjects);
    setAccountObjectServices(newAccountObjectServices);
};

  useEffect(() => {
    if (excursion) {
      loadAccountObjects();
    }
  }, []);

  return (
    <div className="trip-app">
      <div className="trip-app-body">
        {excursion && (
          <>
            <ImageGallery list={excursion.images} />
            {excursion.subdivisions.map((subdivision) => (
              <Section title={subdivision.title} visible={true} key={subdivision.id}>
                <Table cols={3}>
                  <Table.Row>
                    <Table.Cell colspan={3}>
                      <Info title={t('excursion:excursion_info.duration')}>
                        {t('common:duration.day.day', {count: subdivision.getDuration().days})}  {t('common:duration.hour.hour', {count: subdivision.getDuration().hours})}
                      </Info>
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell colspan={3}>
                      <Info title={t('excursion:excursion_info.type')}>
                        {t(`excursion:type.${excursion.type}`)}
                      </Info>
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row delim={true} />
                  <Table.Row>
                    <Table.Cell colspan={3}>
                      <InfoDescription className="header-line" description={t('excursion:excursion_info.price_info')}>
                        {t('excursion:excursion_info.price_on_place')}
                      </InfoDescription>
                    </Table.Cell>
                  </Table.Row>

                  {subdivision.objects && subdivision.objects.map((obj, i) => (
                    <Fragment key={i}>
                      <Table.Row>
                        <Table.Cell key={i} colspan={3}>
                          {obj && accountObjects[obj.id] && (
                            <InfoDescription key={i} description={accountObjects[obj.id].object.address}>
                              {accountObjects[obj.id].title}
                            </InfoDescription>
                          )}
                        </Table.Cell>
                      </Table.Row>
                      {accountObjectServices[obj.id] && (
                        <Fragment>
                          {accountObjectServices[obj.id].map((service, l) => (
                            <Fragment key={l}>
                              <Table.Row>
                                <Table.Cell colspan={3}>
                                  <InfoDescription key={i} description={service.title} />
                                </Table.Cell>
                              </Table.Row>
                              <Table.Row>
                                {service.prices.map((price, j) => (
                                  <Table.Cell key={j} className="price">
                                    <InfoDescription description={price.title}>
                                      <Price currency={CURRENCY.RUB} value={price.price} />
                                    </InfoDescription>
                                  </Table.Cell>
                                ))}
                              </Table.Row>
                            </Fragment>
                          ))}
                        </Fragment>
                      )}
                      <Table.Row delim={true}/>
                    </Fragment>
                  ))}
                </Table>
              </Section>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

ExcursionInfo.propTypes = {
  excursion: PropTypes.object,
  prices: PropTypes.array,
};

export default ExcursionInfo;